import { useState, useCallback } from 'react';
import Auth from '../shared/Auth';
import processChartData from '../utils/processChart';

const useGenerateChartData = ({
  apiService, // api Callback function to call which api
  responseParameter, //data- data key, unit- unit key from the response
  config, // config for creating series and colors dynamically
  selectedObj = null, // selected object for showing line
}) => {
  const [loading, setLoading] = useState(true);
  const [options, setOptions] = useState({});
  const [error, setError] = useState(false);

  const fetchChartData = useCallback(
    async (deviceId, status) => {
      setLoading(true);
      setError(false);
      try {
        const checkToken = await Auth();
        if (checkToken) {
          const numberOfMonths = status.split('-')[1];
          const res = await apiService(deviceId, status);

          if (res.data.statusCode === 200) {
            const result = res.data.result;
            const data = result[responseParameter.data];
            const unit = result.units[responseParameter.unit];

            if (data.length > 0) {
              const chartData = processChartData(
                data,
                { ...config, units: unit },
                selectedObj,
                numberOfMonths
              );

              setOptions({
                ...chartData,
                units: unit,
              });
            } else {
              setOptions({ series: [], config: {} });
            }
          } else {
            setOptions({ series: [], config: {} });
          }
        }
      } catch (error) {
        console.error(error); // Optional: Log error for debugging
        setOptions({ series: [], config: {} });
        setError(true);
      } finally {
        setLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [apiService, config, selectedObj]
  );

  return {
    loading,
    options,
    error,
    fetchChartData,
  };
};

export default useGenerateChartData;
